import { InfoCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Select, Skeleton, Table, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { classNames } from 'src/utilities';
import DrChronoPage from './EHR/drchrono.page';

const EHRIntegrations = () => {
  const [selectedComponent, setSelectedComponent] = useState('drchrono');
  const [textValue, setTextValue] = useState('');

  const handleComponentChange = (value) => {
    setSelectedComponent(value);
    setTextValue(''); // Reset text value when component changes
  };

  const handleTextChange = (e) => {
    setTextValue(e.target.value);
  };

  return (
    <div className="flex-1 pt-4">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex flex-col gap-4 w-full md:w-1/3">
          <div className="text-lg font-bold font-sans pl-1 mb-2">
            Select EHR
          </div>
          <Select
            value={selectedComponent}
            onChange={handleComponentChange}
            style={{
              borderColor: '#d9d9d9',
              borderRadius: '6px',
            }}
            size="small"
            className={classNames(
              'font-sans w-full border border-gray-200',
              'hover:border-blue-400 focus:border-blue-400 rounded-md',
              'single-select'
            )}
          >
            <Select.Option value="drchrono">Dr Chrono</Select.Option>
          </Select>

          {selectedComponent === 'drchrono' && <DrChronoPage />}
        </div>
      </div>
    </div>
  );
};

export default EHRIntegrations;
